var _defs, _path, _path2, _circle, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMenuInvite(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "\\u56FE\\u5C42_1",
    "data-name": "\\u56FE\\u5C42 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 27 27",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#905419;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M8.15,9.75a2.37,2.37,0,0,1,.32-.39H4.28A1.19,1.19,0,0,0,3.19,11L7.69,21.1a1.19,1.19,0,0,0,2.17,0L11,18.65,8,12A2.33,2.33,0,0,1,8.15,9.75Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M8.77,8.72A2.55,2.55,0,1,0,6.23,6.18,2.55,2.55,0,0,0,8.77,8.72Z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 15.24,
    cy: 6.06,
    r: 2.9
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M17.82,16.46h-.64a2.37,2.37,0,1,1,0-4.74h.64v-.65a2.32,2.32,0,0,1,.46-1.39H10.12a1.35,1.35,0,0,0-1.23,1.9L14,23a1.35,1.35,0,0,0,2.47,0l2-4.37a2.35,2.35,0,0,1-.6-1.57Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M23.21,12.72H21.56V11.07a1.37,1.37,0,0,0-2.74,0v1.65H17.18a1.37,1.37,0,1,0,0,2.73h1.64V17.1a1.37,1.37,0,1,0,2.74,0V15.45h1.65a1.37,1.37,0,1,0,0-2.73Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuInvite);
export default __webpack_public_path__ + "static/media/menu_invite.b8e716c8.svg";
export { ForwardRef as ReactComponent };